// Home page V2 model — new storefront design (redesign page d'accueil Directos).
// Every editorial part is expressed as CMS blocks so the whole page stays fully
// translatable through the standard CMS translation flow (see server/api/cms/cms.model.js).
//
// Mixed blocks let a section repeat and mix sub-fields:
//  - `hero`      (max 1)   : image + titre + sous-titre + texte + boutons (plusieurs)
//  - `expertise` (plusieurs): titre + texte + image + tags (plusieurs)  → "Savoir-faire"
//  - `extra`     (plusieurs): titre + sous-titre + texte                → "Bon à savoir"
//
// The shipping/delivery/order + content/subcontent blocks are kept identical to the
// original HomePageModel so existing content and the shared panels keep working.
const HomePageV2Model = {
    type: 'page',
    name: 'homeV2',
    slug: '*',
    blocks: [
        {
            name: 'hero',
            type: 'mixed',
            max: 1,
            blocks: [
                {
                    name: 'eyebrow', // short kicker above the title
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'image', // hero background photo
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'title', // H1 — main headline
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'subtitle', // lead paragraph under the title
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'text', // secondary text / reassurance
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'buttons', // call-to-action buttons (several); link.color = bootstrap variant
                    type: 'link',
                },
            ],
        },
        {
            name: 'expertise',
            type: 'mixed',
            blocks: [
                {
                    name: 'title', // H3 — slide title
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'text', // slide description
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'tags', // labels (several)
                    type: 'text',
                },
            ],
        },
        // Intro paragraph shown next to the "Savoir-faire" slider (kept for continuity
        // with the original model, also used as a generic rich-text area).
        {
            name: 'content',
            type: 'html',
            max: 1,
        },
        {
            name: 'extra',
            type: 'mixed',
            blocks: [
                {
                    name: 'title', // H3 — card title
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'subtitle', // eyebrow / category above the title
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'text', // card body
                    type: 'html',
                    max: 1,
                },
            ],
        },
        {
            name: 'subcontent',
            type: 'html',
            max: 1,
        },
    ],
};

export default HomePageV2Model;
